import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function BasicSelect({ items,
    labelId,
    labelText,
    selectId,
    onChange,
    defaultValues
    }) {
    const [selectedItem, setSelectedItem] = React.useState(defaultValues ?? []);

    const handleChange = (event) => {
        setSelectedItem(event.target.value);
        if (onChange) {
            onChange(event, event.target.value);
        }
    };

    const SelectFieldStyle = {
        fontSize: "0.75rem",
        padding: "8px",
        paddingBottom: "13px"
    };

    return (
        <Box>
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small" >
                <InputLabel id={labelId}>{ labelText }</InputLabel>
                <Select
                    labelId={labelId}
                    id={selectId}
                    value={selectedItem}
                    label={labelText }
                    onChange={handleChange}
                    autoWidth
                    SelectDisplayProps={{
                        style: SelectFieldStyle,
                    }}
                >
                    {items.map((i, index) => (
                        <MenuItem key={index} value={i.value}>{ i.text }</MenuItem>
                    ))}

                </Select>
            </FormControl>
        </Box>
    );
}